/** Small readers shared by the facility inspection screens. */
import { formItems, type Trade } from "../../domain/assetInspections";

/** The words of a checklist item, from either form. */
export function itemText(trade: Trade, itemId: string): string {
  return (
    formItems(trade, "daily").find((i) => i.id === itemId)?.text ??
    formItems(trade, "detailed").find((i) => i.id === itemId)?.text ??
    itemId
  );
}

export const sar = (n: number) => `SAR ${Math.round(n).toLocaleString("en-US")}`;
